import { useIsFetching } from '@tanstack/react-query';
import { useDebounce } from 'use-debounce';
import cn from '@/utils/merge-class-names';

interface Props {
  className?: string;
}

export default function MessageStateIndicator({ className }: Props) {
  const isFetchingMessages = useIsFetching({
    predicate: ({ queryHash }) => !!queryHash.match(/GetChatData|GetGroupChatData/gi),
  });
  const [debouncedVisible] = useDebounce(isFetchingMessages, 1500);

  if (!debouncedVisible) return null;

  return (
    <span className={cn('loading loading-spinner loading-sm m-2 text-base-content/50 opacity-20 !size-4', className)} />
  );
}
